import { Component, OnInit, HostListener, ViewChild, PLATFORM_ID, Inject, OnDestroy, ViewChildren, QueryList, inject, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, AfterViewInit, NgZone, ElementRef } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Meta, Title } from '@angular/platform-browser';
import { Experience } from 'src/app/services/experience.service';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import * as globalConstant from '../../../global_constant';
import { AddExperience } from 'src/app/services/AddExperience.service';
import { CartService } from 'src/app/services/cart.service';
import { MessageService } from '../../../message.service';
import { ExperienceDetailsService } from 'src/app/services/experience-details.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { DatepickerDateCustomClasses, BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { DatePipe, isPlatformBrowser } from '@angular/common';
import { Location } from '@angular/common';
import { FilterService } from 'primeng/api';
import { SharedModule } from '../../../share/shared.module';
import { ToastrService } from 'src/app/services/toastr.service';
import { CanonicalService } from 'src/app/services/canonical.service';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';



@Component({
	selector: 'app-location-region-category',
	standalone: true,
	imports: [
		SharedModule,
		NgxSkeletonLoaderModule
	],
	templateUrl: './location-region-category.component.html',
	styleUrls: ['./location-region-category.component.css'],
	schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class LocationRegionCategoryComponent implements OnInit, OnDestroy, AfterViewInit {

	@ViewChild('buymodal', { static: false }) public buymodal: ModalDirective;
	@ViewChildren('allExperiences') allExperienceLoad: QueryList<any>;
	private _picker: BsDatepickerDirective;
	isMobile: boolean = false;
	isBrowser: boolean;
	locationSlug = '';
	categorySlug = '';
	combinedSlug = '';
	image_url = '';
	amount_value: any = '';
	max_quantity_count: number = 10;
	searchSort: boolean = false;
	image_url_exp = '';
	searchKeyword: string;
	submitted: boolean = false;
	page: number = 1;
	last_page: number = 0;
	totalRecord: number = 0;
	current_page: number = 0;
	purchaseExpID: any;
	purchaseExpSlug: any;
	purchaseExpTitle: any;
	purchaseExpImage: any;
	purchaseExpType: any;
	purchaseExpPrice: any;
	purchaseExpQuantity: any;
	purchaseExpVerID: any;
	purchaseExpTax: any;
	result: any = [];
	resultExp: any = [];
	bannerDisplayData: any = [];
	featuresList: any = [];
	weatherFeaturesList: any = [];
	country_list: any = [];
	state_List: any = [];
	city_List: any = [];
	selected_country_id: number = 0;
	selected_state_id: number = 0;
	selected_city_id: number = 0;
	price_filter_search: any = {};
	certificate_data: any = '';
	isLoading = false;
	noRecordFound = false;
	scrollEnable = false;
	isUserLogin: boolean = false;
	tokenkey: any = ''
	showRegChkmark: boolean = false;
	keyword = 'value';
	data: any = [];
	type = '';
	search_id = '';
	select_data: any = '';
	subscription: Subscription;
	getExpStatusChangedToMainComponentSubscription: Subscription;
	amount: number = 0;
	search_type: string = '';
	bannerDisplayDataLenth: any = '';
	authUser: any;

	experienceDetails: any = '';
	data_for_dropdown_in_popup: any = '';
	clickCart: any = '';
	base_url: any = '';
	is_booking: number = 0;
	dateCustomClasses: DatepickerDateCustomClasses[];
	minDate = new Date();
	maxDate: Date;
	selectedDateRange: any = []
	selected_date = '';
	total_exp: any = '';
	start_date: any = '';
	end_date: any;
	save_filter_event: any = "";
	autocompleteData: any = [];
	modelChanged: Subject<any> = new Subject<any>();
	modelChanged2: Subject<any> = new Subject<any>();

	public fields: Object = { groupBy: 'category', value: 'value' };

	is_offset: any = '';
	exp_pos: any = '';

	enable_rfp_225: any = globalConstant.ENABLE_RFP_225;
	view_on_map: boolean = false;
	mapview: any;

	latitude: any;
	longitude: any;
	currentIW: any = '';
	previousIW: any = '';
	pageSize: number = 20;
	search_with_map: boolean = false;
	googlemap: any;
	lat_long: any = '';
	fitbounds: boolean = false;
	map_zoom = 6;
	testDiv: any;
	isCookies: boolean;
	searchHistory: any[] = [];
	searchHistorySave: any[] = [];
	resultContent: any = [];
	searchedItem: string;
	location_travel: any;
	location: any;
	city: any;
	at_home: any;
	groupedData: any[] = [];
	filteredGroups: any[] = [];
	Query: any;
	isDataLoading: boolean = false;
	isDateSelected: boolean = false;
	gridView: boolean;
	@ViewChildren('videoElement') videos!: QueryList<ElementRef<HTMLVideoElement>>;
	observer!: IntersectionObserver;
	foundResultData: boolean = false;

	constructor(private experience: Experience,
		private breakpointObserver: BreakpointObserver,
		private router: Router,
		private addexperience: AddExperience,
		private cartService: CartService,
		private messageService: MessageService,
		private ExpDetailService: ExperienceDetailsService,
		private _location: Location,
		public datePipe: DatePipe,
		public toastr: ToastrService,
		private ngZone: NgZone,
		private canonicalService: CanonicalService,
		private activatedRoute: ActivatedRoute,
		private filterService: FilterService,
		private metaService: Meta,
		private title: Title,
		@Inject(PLATFORM_ID) platformId: Object
	) {
		let currenturl = this.router.url;
		let componentUrl = currenturl.startsWith('/') ? currenturl.slice(1) : currenturl;
		const canonicalUrl = this.normalizeUrl(this.siteUrl + componentUrl);
		this.pageUrl = canonicalUrl;
		this.canonicalService.setCanonical(canonicalUrl);
		this.isBrowser = isPlatformBrowser(platformId);

		if (this.isBrowser) {
			this.base_url = location.origin + '/experiences/';
		}
		this.locationSlug = this.router?.url?.split("/")[2];
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		if (this.router?.url?.split("/")[3] && this.router?.url?.split("/")[3]?.split("?")) {
			this.categorySlug = this.router?.url?.split("/")[3]?.split("?")[0];
		} else {
			this.categorySlug = this.router?.url?.split("/")[3];
		}
		if (this.locationSlug && this.categorySlug) {
			this.combinedSlug = this.locationSlug + '/' + this.categorySlug;
		}

		this.modelChanged.pipe(debounceTime(100)).subscribe(sub => {
			if (sub.text.replace(/^\s+|\s+$/gm, '').length >= 3)
				this.onFiltering_after_debounce(sub);
		});

		this.getLocationRegionData();

		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				this.locationSlug = this.router?.url?.split("/")[2];
				if (this.router?.url?.split("/")[3] && this.router?.url?.split("/")[3]?.split("?")) {
					this.categorySlug = this.router?.url?.split("/")[3]?.split("?")[0];
				} else {
					this.categorySlug = this.router?.url?.split("/")[3];
				}

				// this.getLocationRegionData();
			}
		});

		this.activatedRoute.queryParams.subscribe(params => {
			if (params['page']) {
				this.page = parseInt(params['page']);
				if (this.page == 0) {
					this.page = 1;
				}
			}
			this.selectedDateRange = []
			if (params['start_date']) {
				this.start_date = params['start_date'];
				if (this.start_date) {
					this.selectedDateRange.push(this.datePipe.transform((this.start_date), 'MM-dd-yyyy'))
				}
			}
			if (params['end_date']) {
				this.end_date = params['end_date'];
				if (this.end_date) {
					this.selectedDateRange.push(this.datePipe.transform((this.end_date), 'MM-dd-yyyy'))
				}
			}
			if (params['is_booking']) {
				this.is_booking = parseInt(params['is_booking']);
			}
			if (params['exp_pos']) {
				this.exp_pos = parseInt(params['exp_pos']);
				this.is_offset = 1;
			} else {
				if (this.isBrowser) {
					window.scrollTo(0, 0);
				}
			}
		})
		if (this.isBrowser) {
			if (localStorage.getItem('authUser')) {
				this.tokenkey = localStorage.getItem('login_token');
				this.authUser = JSON.parse(localStorage.getItem('authUser'));

				this.isUserLogin = true;
			}
			else {
				this.tokenkey = ''
				this.isUserLogin = false
			}
		}



		this.getExpStatusChangedToMainComponentSubscription = this.messageService.getExpStatusChangedToMainComponent().subscribe(message => {
			if (typeof message.type != "undefined" && message.exp_id != "undefined") {
				this.updateRegistryStatusOnExpList(message.exp_id, message.is_registry_status, message.added_registry_type, message.experience_status, message.experience_status_msg); // calls function to update registry status if changes from popup.
			}
		});
		const now = new Date();
		this.dateCustomClasses = [
			{ date: now, classes: ['bg-warning'] },
		];

		this.modelChanged2.pipe(debounceTime(100)).subscribe(query => {
			if (query.trim().length >= 1) {
				this.onFilteringAfterDebounce(query);
			}
		});
	}

	@HostListener('window:scroll', [])
	onWindowScroll() {
		if (this.isBrowser && this.view_on_map == false) {
			var windowScrollTop = (document.documentElement.scrollTop || document.body.scrollTop);

			if (this.scrollEnable && this.isDataLoading === false) {
				if (windowScrollTop > (document.documentElement.scrollHeight - window.innerHeight) - 70) {
					if (this.page <= this.last_page) {

						// Check for valid start_date and end_date
						const startDateParam = this.start_date !== undefined && this.start_date !== null ? this.start_date : '';
						const endDateParam = this.end_date !== undefined && this.end_date !== null ? this.end_date : '';

						this._location.replaceState('/location-region/' + this.locationSlug + '/' + this.categorySlug +
							"?page=" + this.page + "&exp_pos=" + ((this.page * 9) - 5) + "&is_booking=" + this.is_booking +
							(this.is_booking > 0 ? ("&start_date=" + startDateParam + "&end_date=" + endDateParam) : ''));
						this.is_offset = 0;

						this.getAllExperienceData();
					}
				}
			}
		}

		/*if(this.isBrowser && this.view_on_map){

			var HeadH = document.getElementById("header").clientHeight
			var midHeigh = document.getElementById("midleHeight").clientHeight

			const currentScroll = window.pageYOffset;
			if (currentScroll >= this.testDiv + midHeigh ) {
				document.getElementsByTagName('body')[0].classList.add('mapfixed');
				document.getElementById('mapContFix').style.top = HeadH + 'px';
			}
			else{
				document.getElementsByTagName('body')[0].classList.remove('mapfixed');
			}
		}*/
	};

	ngAfterViewInit() {
		if (this.isBrowser) {
			if (window.innerWidth < 768) {
				this.isMobile = true
				this.gridView = false;
			} else {
				this.isMobile = false;
				this.gridView = true;
			}
			this.allExperienceLoad.changes.subscribe(t => {
				if (this.is_offset == 1 && this.exp_pos > 0) {
					if (this.isBrowser) {
						var elmnt = document.getElementById(this.exp_pos);
						if (elmnt)
							elmnt.scrollIntoView();
					}
				}
			});
			this.showVideo();
		}
	}

	buildThresholdList() {
		const thresholds = [];
		const numSteps = 20;
		for (let i = 1; i <= numSteps; i++) {
			thresholds.push(i / numSteps);
		}
		return thresholds;
	}

	showVideo() {
		if (this.isBrowser) {
			const options: IntersectionObserverInit = {
				root: null,
				threshold: this.buildThresholdList()
			};

			this.ngZone.runOutsideAngular(() => {
				this.observer = new IntersectionObserver(this.handleIntersect.bind(this), options);

				this.videos.forEach(videoRef => {
					const video = videoRef.nativeElement;
					video.preload = 'metadata'; // prevent network overload
					video.pause(); // ensure all are paused initially
					this.observer.observe(video);
				});

				// Also re-evaluate on resize/scroll in case layout shifts
				window.addEventListener('resize', this.recheckObserver);
				window.addEventListener('scroll', this.recheckObserver, true);
			});
		}
	}

	private handleIntersect(entries: IntersectionObserverEntry[]) {
		let maxRatio = 0;
		let mostVisibleVideo: HTMLVideoElement | null = null;

		entries.forEach(entry => {
			const ratio = entry.intersectionRatio;
			if (ratio > maxRatio) {
				maxRatio = ratio;
				mostVisibleVideo = entry.target as HTMLVideoElement;
			}
		});

		if (mostVisibleVideo) {
			this.videos.forEach(videoRef => {
				const video = videoRef.nativeElement;
				if (video === mostVisibleVideo) {
					video.play().catch(() => { });
				} else {
					video.pause();
				}
			});
		}
	}

	private recheckObserver = () => {
		this.videos.forEach(videoRef => {
			const video = videoRef.nativeElement;
			this.observer.unobserve(video);
			this.observer.observe(video);
		});
	};

	siteUrl: String = globalConstant?.WEBSITE_URL;
	pageUrl: any = '';
	isMobileView: any;


	experiencefindUpdate = new Subject<string>();


	normalizeUrl(url: string): string {
		return url.endsWith('/') ? url.slice(0, -1) : url; // Remove trailing slash if present
	}


	updateRegistryStatusOnExpList(exp_id, registry_status, type, status, status_msg) {
		if (this.resultExp.length > 0) {
			for (let i = 0; i < this.resultExp.length; i++) {
				if (this.resultExp[i].id == exp_id) {
					this.resultExp[i].is_show_ckbx = 0;    // hide vebo V image.
					this.resultExp[i].experience_status_msg = status_msg;
					this.resultExp[i].added_registry_type = type;
					this.resultExp[i].experience_status = status;
					this.resultExp[i].is_registry_status = registry_status;
					break;
				}
			}
		}

	}

	ngOnInit() {
		if(this.is_booking == 0) {
			this.getAllExperienceData();
		}
		this.experiencefindUpdate.pipe(
			debounceTime(1000),
			distinctUntilChanged())
			.subscribe(value => {
				this.select_data = value
				if (this.data.length > 0) {
					for (let i = 0; i < this.data.length; i++) {
						if (this.data[i].value == this.select_data.value) {
							this.type = this.data[i].type;
							this.search_id = this.data[i].id;
						}
					}
				}
				this.resultExp = [];
				this.last_page = 0;
				this.current_page = 0;
				this.page = 1;
				this.noRecordFound = false;
				this.isLoading = false;
				this.isDataLoading = false;
				this.getAllExperienceData();
			});

		if (this.isBrowser) {
			if (document.getElementById("mapParent_2")) {
				this.testDiv = document.getElementById("mapParent_2").offsetTop;
			}

			this.isCookies = this.getCookie('acceptCookies') !== "";
			this.searchHistory = JSON.parse(localStorage.getItem('searchHistory')) || [];
		}

	}

	getCookie(data) {
		let name = data + "=";
		let ca = document?.cookie?.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}



	saveRecentSearch(newSearch) {
		if (this.isBrowser) {
			let searchHistory = JSON.parse(localStorage.getItem('searchHistory')) || [];
			if (newSearch?.id !== null) {
				searchHistory = searchHistory.filter(exp => exp?.title !== newSearch?.title);
			} else {
				searchHistory = searchHistory.filter(exp => !(exp.id === newSearch?.id && exp?.type === newSearch?.type));
			}

			// Add the new search entry to the top
			if (Object.keys(newSearch)?.length > 0) {
				searchHistory.unshift(newSearch);
			}
			// Ensure only the last 5 experiences are stored
			if (searchHistory?.length > 5) {
				searchHistory = searchHistory.slice(0, 5);
			}

			this.searchHistorySave = searchHistory;
			localStorage.setItem('searchHistory', JSON.stringify(this.searchHistorySave));
		}
	}


	getLocationRegionData() {
		this.experience.getLocationRegion(this.locationSlug, this.categorySlug).subscribe(res => {
			if (res.response == "success") {
				this.foundResultData = true;
				this.result = res?.data;
				if (this.isCookies && this.result.id !== undefined && this.result.id !== null) {
					const newSearch = {
						id: this.result?.id,
						title: this.result?.name,
						image_url: this.result?.image,
						params: this.combinedSlug,
						city: '',
						location_type: '2',
						type: 'location-list'
					};
					this.saveRecentSearch(newSearch);
				} else if (this.isCookies && !this.resultContent.id) {
					if (this.isBrowser) {
						const searchHistory = JSON.parse(localStorage.getItem('searchHistory')) || [];
						this.searchHistorySave = searchHistory;
					}
				}

				this.selected_state_id = this.result.parent_id;

				this.latitude = Number(this.result.latitude);
				this.longitude = Number(this.result.longitude);
				this.map_zoom = Number(this.result.map_zoom);

				this.image_url = res.image_url;
				this.bannerDisplayData = res.data.banner_display_data != '' && res.data.banner_display_data != undefined ? JSON.parse(res.data.banner_display_data) : [];
				this.bannerDisplayDataLenth = Object.keys(this.bannerDisplayData).length;
				this.featuresList = res.data.feature_list;
				this.weatherFeaturesList = res.data.weather_feature_list;
				this.addMetaTags();

			} else {
				this.foundResultData = false;
			}
		});
	}

	tab_change(is_booking = 0) {
		if (this.is_booking == is_booking) {
			return;
		}

		this.currentIW = '';
		this.previousIW = '';
		this.is_booking = is_booking;
		if (is_booking == 0) {
			this.end_date = ''
			this.start_date = ''
			this.selectedDateRange = []
		} else if (is_booking == 2) {
			if (this.start_date && this.end_date) {
				this.selectedDateRange[0] = new Date(this.datePipe.transform((this.start_date), 'MM-dd-yyyy'))
				this.selectedDateRange[1] = new Date(this.datePipe.transform((this.end_date), 'MM-dd-yyyy'))
			} else {
				this.selectedDateRange = []
			}
			this.start_date = this.start_date ? this.datePipe.transform((this.start_date), 'yyyy-MM-dd') : ''
			this.end_date = this.end_date ? this.datePipe.transform((this.end_date), 'yyyy-MM-dd') : ''
		} else {
			if (this.start_date && this.end_date) {

				this.selectedDateRange[0] = new Date(this.datePipe.transform((this.start_date), 'MM-dd-yyyy'))
				this.selectedDateRange[1] = new Date(this.datePipe.transform((this.end_date), 'MM-dd-yyyy'))
				this.start_date = this.start_date ? this.datePipe.transform((this.start_date), 'yyyy-MM-dd') : ''
				this.end_date = this.end_date ? this.datePipe.transform((this.end_date), 'yyyy-MM-dd') : ''
			} else {
				this.selectedDateRange = []
			}
			!this.selectedDateRange?.length ? this.start_date = '' : this.start_date
			!this.selectedDateRange?.length ? this.end_date = '' : this.end_date
		}

		this.page = 1;
		this.selected_date = '';
		this.current_page = 1;
		this.last_page = 1;
		this.exp_pos = 0;
		this.resultExp = [];
		this.certificate_data = [];
		this.start_date = this.start_date ? this.datePipe.transform((this.start_date), 'yyyy-MM-dd') : '';
		this.end_date = this.end_date ? this.datePipe.transform((this.end_date), 'yyyy-MM-dd') : '';
		let setUrl = '/location-region/' + this.locationSlug + '/' + this.categorySlug +
			"?page=" + this.page + "&exp_pos=" + this.exp_pos + "&is_booking=" + is_booking +
			(is_booking > 0 ? ("&start_date=" + this.start_date + "&end_date=" + this.end_date) : '');
		this._location.replaceState(setUrl);
		if (this.is_booking == 0) {
			this.getAllExperienceData();
		}
	}

	onShowPicker(event) {
		if (this.isBrowser) {
			const dayHoverHandler = event.dayHoverHandler;
			const hoverWrapper = (hoverEvent) => {
				const { cell, isHovered } = hoverEvent;
				if ((isHovered &&
					!!navigator.platform &&
					/iPad|iPhone|iPod/.test(navigator.platform)) &&
					'ontouchstart' in window
				) {
					(this._picker as any)._datepickerRef.instance.daySelectHandler(cell);
				}

				return dayHoverHandler(hoverEvent);
			};
			event.dayHoverHandler = hoverWrapper;
			this.isDateSelected = true;
		}
	}


	map_view(mapview) {
		this.view_on_map = mapview.target.checked;
		this.currentIW = '';
		this.previousIW = '';
		this.page = 1;
		this.current_page = 1;
		this.last_page = 1;
		this.resultExp = [];
		if (this.isBrowser && this.view_on_map) {
			this.search_with_map = true;
		} else {
			this.search_with_map = false;
			this.lat_long = "";
		}
		this.getAllExperienceData();
	}

	searchWithMap(event) {
		//this.search_with_map = event.target.checked;
		this.search_with_map = event;
		this.fitbounds = false;
		if (this.search_with_map) {
			google.maps.event.addListener(this.googlemap, 'dragend', () => {
				this.currentIW = '';
				this.previousIW = '';
				var bounds = this.googlemap.getBounds();
				this.lat_long = bounds.toJSON();
				this.page = 1;
				this.current_page = 1;
				this.last_page = 1;
				this.getAllExperienceData();
			});

			this.currentIW = '';
			this.previousIW = '';
			var bounds = this.googlemap.getBounds();
			this.lat_long = bounds.toJSON();
			this.page = 1;
			this.current_page = 1;
			this.last_page = 1;
			this.getAllExperienceData();

		} else {
			google.maps.event.clearListeners(this.googlemap, 'dragend');
			this.currentIW = '';
			this.previousIW = '';
			this.lat_long = '';
		}
	}

	map_image_enter(index: any) {
		let image = this.resultExp[index]?.map_image_url;
		if (this.resultExp[index]?.map_image) {
			this.resultExp[index].map_image = { url: image, scaledSize: { width: 50, height: 50 } };
		}
		if (this.resultExp[index]?.zindex) {
			this.resultExp[index].zindex = 5;
		}
	}

	map_image_out(index: any) {
		let image = this.resultExp[index]?.map_image_url;
		if (this.resultExp[index]?.map_image) {
			this.resultExp[index].map_image = { url: image, scaledSize: { width: 35, height: 35 } };
		}
		if (this.resultExp[index]?.zindex) {
			this.resultExp[index].zindex = 1;
		}
	}

	onMouseClick(index: any, infoWindow) {

		let image = this.resultExp[index]?.map_image_url;
		if (this.resultExp[index]?.map_image) {
			this.resultExp[index].map_image = { url: image, scaledSize: { width: 36, height: 36 } };
		}

		let marker = infoWindow.hostMarker;
		//let pixelOff 	=	this.getInfowindowOffset(this.googlemap, {'lng':function(){return marker.longitude}, 'lat':function(){return marker.latitude}});
		//infoWindow._setInfoWindowOptions({ pixelOffset: pixelOff });
		infoWindow.open();

		if (this.previousIW) {
			this.currentIW = infoWindow;
			this.previousIW.close();
		}
		this.previousIW = infoWindow;
	}

	getInfowindowOffset(map, marker) {
		var center = this.getPixelFromLatLng(map.getCenter()),
			point = this.getPixelFromLatLng(marker),
			quadrant = "",
			offset;

		quadrant += (point.y > center.y) ? "b" : "t";
		quadrant += (point.x < center.x) ? "l" : "r";
		if (quadrant == "tr") {
			offset = new google.maps.Size(-180, 420);
		} else if (quadrant === "tl") {
			offset = new google.maps.Size(180, 420);
		} else if (quadrant === "br") {
			offset = new google.maps.Size(-150, 60);
		} else if (quadrant === "bl") {
			offset = new google.maps.Size(150, 60);
		}
		return offset;
	};

	getPixelFromLatLng(latLng) {
		var projection = this.googlemap.getProjection();
		var point = projection.fromLatLngToPoint(latLng);
		return point;
	};

	pageChanged(eve) {
		this.currentIW = '';
		this.previousIW = '';
		this.page = eve;
		this.current_page = eve;
		if (this.search_with_map) {
			this.fitbounds = false;
		} else {
			this.fitbounds = true;
		}
		this.getAllExperienceData();
	}

	zoomChange(event) {
		if (this.search_with_map) {
			this.currentIW = '';
			this.previousIW = '';
			this.page = 1;
			this.current_page = 1;
			this.last_page = 1;
			var bounds = this.googlemap.getBounds();
			this.lat_long = bounds.toJSON();
			var center = this.googlemap.getCenter();
			this.latitude = center.lat();
			this.longitude = center.lng();
			this.getAllExperienceData();
		}
	}

	public mapReady(map) {
		this.googlemap = map;
		google.maps.event.addListener(this.googlemap, 'dragend', () => {
			this.currentIW = '';
			this.previousIW = '';
			var bounds = this.googlemap.getBounds();
			this.lat_long = bounds.toJSON();
			var center = this.googlemap.getCenter();
			this.latitude = center.lat();
			this.longitude = center.lng();
			this.page = 1;
			this.current_page = 1;
			this.last_page = 1;
			this.getAllExperienceData();
		});

		/*const bounds = new google.maps.LatLngBounds();
	  for (const mm of this.resultExp) {
		bounds.extend(new google.maps.LatLng(mm.latitude, mm.longitude));
	  }
	  map.fitBounds(bounds);*/

		map.setOptions({
			zoomControl: 'true',
			zoomControlOptions: {
				position: google.maps.ControlPosition.TOP_LEFT
			}
		});
	}

	getAllExperienceData() {
		if (this.searchSort) {
			this.page = 1;
		}
		// if ((this.last_page >= this.page || this.last_page == 0) && this.current_page <= this.last_page) {
		// this.isLoading = true;

		this.isDataLoading = true;

		let requestbody = {
			'location_slug': this.categorySlug,
			'page': this.page,
			'search_id': this.search_id,
			'type': this.type,
			'is_booking': this.is_booking,
			'start_date': this.datePipe.transform(this.start_date, 'yyyy-MM-dd'),
			'end_date': this.datePipe.transform(this.end_date, 'yyyy-MM-dd'),
			'is_offset': this.is_offset,
			'lat_long': this.lat_long,
			'view_on_map': this.view_on_map,
			'latitude': this.latitude,
			'longitude': this.longitude,
			'title': this.searchedItem,
		};
		this.experience.getExperienceByLocation1(requestbody, this.tokenkey).subscribe(res => {
			if (res.response == 'success') {
				if (this.is_booking == 2) {
					if (res?.data?.events && res?.data?.events?.length > 0) {
						var responseData = res?.data?.events;
						var paginationData = res?.data;

						for (let i = 0; i < Object.keys(responseData).length; i++) {
							responseData[i].map_image = { url: responseData[i].image_url, scaledSize: { width: 35, height: 35 } };
							responseData[i].zindex = 1;
						}

						if (this.view_on_map) {
							this.resultExp = responseData;
							this.getExpQuantity(this.resultExp)
							if (this.isBrowser) {
								// setTimeout(function () {
								// 	var stickySidebar = new StickySidebar("#stickyMap_2", {
								// 		topSpacing: 78
								// 	});
								// }, 4000);
							}
						} else {
							this.resultExp = [...this.resultExp, ...responseData];
							this.getExpQuantity(this.resultExp)
						}

						this.pageSize = paginationData?.per_page;
						this.totalRecord = paginationData?.total;
						this.last_page = paginationData?.last_page;
						this.scrollEnable = true;
						if (!this.view_on_map) {
							this.current_page = paginationData?.current_page + 1;
							this.page += 1;
						}
					} else {
						this.resultExp = [];
						this.scrollEnable = false;
					}

				} else {
					let favAndInstantArr = [];
					let instantArr = [];
					let favArr = [];
					let bothNoneArr = [];
					res.data.data.forEach(item => {
						if (item.favorite == 1 && item.instant_book == 1) {
							favAndInstantArr.push(item);
						} else if (item.favorite == 1 && item.instant_book == 0) {
							favArr.push(item);
						} else if (item.favorite == 0 && item.instant_book == 1) {
							instantArr.push(item);
						} else if (item.favorite == 0 && item.instant_book == 0) {
							bothNoneArr.push(item);
						}
					});
					if (favAndInstantArr?.length > 0) {
						favAndInstantArr.forEach((item, i) => {
							const j = Math.floor(Math.random() * (i + 1));
							[favAndInstantArr[i], favAndInstantArr[j]] = [favAndInstantArr[j], favAndInstantArr[i]];
						})
					}
					if (favArr?.length > 0) {
						favArr.forEach((item, i) => {
							const j = Math.floor(Math.random() * (i + 1));
							[favArr[i], favArr[j]] = [favArr[j], favArr[i]];
						})
					}
					if (instantArr?.length > 0) {
						instantArr.forEach((item, i) => {
							const j = Math.floor(Math.random() * (i + 1));
							[instantArr[i], instantArr[j]] = [instantArr[j], instantArr[i]];
						})
					}
					if (bothNoneArr?.length > 0) {
						bothNoneArr.forEach((item, i) => {
							const j = Math.floor(Math.random() * (i + 1));
							[bothNoneArr[i], bothNoneArr[j]] = [bothNoneArr[j], bothNoneArr[i]];
						})
					}
					var responseData: any = [...favAndInstantArr, ...favArr, ...instantArr, ...bothNoneArr]
					// var responseData = res.data.data;
					for (let i = 0; i < responseData.length; i++) {
						responseData[i].map_image = { url: responseData[i].image_url, scaledSize: { width: 35, height: 35 } };
						responseData[i].zindex = 1;
						if (responseData[i].variations_data.length > 0) {
							for (let k = 0; k < responseData[i].variations_data.length; k++) {
								if (responseData[i].variations_data[k].slug == 'buy-for-yourself') {
									responseData[i].is_buy_for_yourself = 1;
									responseData[i].buy_for_yourself_veriation_id = responseData[i].variations_data[k].id;
									break;
								} else {
									responseData[i].is_buy_for_yourself = 0;
									responseData[i].buy_for_yourself_veriation_id = 0;
								}
							}
						} else {
							responseData[i].is_buy_for_yourself = 0;
							responseData[i].buy_for_yourself_veriation_id = 0;
						}
					}

					if (this.view_on_map) {
						this.resultExp = responseData;
						this.getExpQuantity(this.resultExp)
						if (this.isBrowser) {
							// setTimeout(function () {
							// 	var stickySidebar = new StickySidebar("#stickyMap_2", {
							// 		topSpacing: 78
							// 	});
							// }, 4000);
						}
					} else {
						this.resultExp = [...this.resultExp, ...responseData];
						this.getExpQuantity(this.resultExp)
					}

					//this.resultExp 			= 	[...this.resultExp,...responseData];
					this.total_exp = Object.keys(this.resultExp).length;
					this.certificate_data = res.certificate_data;
					/* if(this.is_offset==1){
						setTimeout(()=>{
							if(this.isBrowser){
								var elmnt = document.getElementById(this.exp_pos);
								if(elmnt)
									elmnt.scrollIntoView();	
							}
						},10);
					} */
					this.image_url_exp = res.experience_image_url;
					this.scrollEnable = true;
					this.pageSize = res.data.per_page;
					this.totalRecord = res.data.total;
					if (this.totalRecord == 0) {
						this.noRecordFound = true;
					} else {
						this.noRecordFound = false;
					}
					this.last_page = res.data.last_page;

					if (!this.view_on_map) {
						this.current_page = res.data.current_page + 1;
						this.page += 1;
					}

				}

				//this.current_page = res.data.current_page+1;
				//this.page += 1;
				this.isDataLoading = false;

			} else if (res.response == 'error') {
				this.noRecordFound = true;
				this.scrollEnable = false;
				this.isDataLoading = false;
			}

			if (this.isBrowser) {
				document.getElementById('loader')?.click();	// Loading problem solution on map view when user drag on the map.
			}

			this.isLoading = false;
			this.isDataLoading = false;

		});
		// }
	}

	/* OPEN ADD TO CART FOR NON LOGGEDIN USERS POPUP */
	openDialog(record, price, type, tax = 0, data, componentName = 'location-region-category') {
		if (data['key']) {
			data['key'] = this.authUser?.role_id == 4 ? ((!record?.for_individual_price || record?.for_individual_price == 0) ? 2 : 1) : data?.key
		}
		//this.close();
		if (record?.is_buy_for_yourself == 1) {

			if (this.isBrowser) {
				var element = document.querySelector("body");
				var htmlelement = document.querySelector("html")

				if (element) {
					element.classList.add('overflow');
				}
				if (htmlelement) {
					htmlelement.classList.add('overflow');
				}
			}

			this.clickCart = "overflow_remove"
			var qty = record.alternate_quantity == 1 ? data?.qty : 1;
			let gratuity = record?.gratuity ? record?.gratuity : 0
			if (record.alternate_quantity == 1) {
				var taxValue = ((price * qty) * tax / 100);
				var gratuityValue = ((price * qty) * gratuity / 100);
				this.purchaseExpPrice = price;
			} else {
				if (this.isUserLogin && this.authUser?.role_id != 4) {
					var taxValue = ((price * qty) * tax / 100);
					var gratuityValue = ((price * qty) * gratuity / 100);
					this.purchaseExpPrice = price
				} else {
					if (data?.key > 1 && record?.for_individual_price > 0) {
						var taxValue = (((price * data?.key) * qty) * tax / 100);
						var gratuityValue = (((price * data?.key) * qty) * gratuity / 100);
						this.purchaseExpPrice = price * data?.key
					} else {
						var taxValue = ((price * qty) * tax / 100);
						var gratuityValue = ((price * qty) * gratuity / 100);
						this.purchaseExpPrice = price
					}
				}
			}

			this.purchaseExpID = record?.id;
			this.purchaseExpSlug = record?.slug;
			this.purchaseExpTitle = record?.title;
			this.purchaseExpImage = record?.image_url;
			this.purchaseExpType = type;
			this.purchaseExpVerID = record?.buy_for_yourself_veriation_id;
			this.purchaseExpQuantity = qty;
			this.purchaseExpTax = taxValue;
			let pusheditems = {};
			var cartitems: any = [];
			if (this.isBrowser) {
				if (localStorage.getItem('cart_details')) {
					cartitems = JSON.parse(localStorage.getItem('cart_details'));
				}
			}
			let hasPresentOn = cartitems.find(
				function (el) {
					if (el.product_id === record?.id) {
						return true;
					} else {
						return false;
					}
				}
			);
			if (!hasPresentOn) {
				if (this.authUser && (this.authUser.role_id == 5 || this.authUser.role_id == 1)) {
					pusheditems['voucher_name'] = this.authUser.first_name + ' ' + this.authUser.last_name + ' & ' + this.authUser.partner_first_name + ' ' + this.authUser.partner_last_name;
				} else if (this.authUser && this.authUser.role_id == 4) {
					pusheditems['voucher_name'] = this.authUser.first_name + ' ' + this.authUser.last_name
				}
				pusheditems['product_id'] = this.purchaseExpID;
				pusheditems['title'] = this.purchaseExpTitle;
				pusheditems['slug'] = this.purchaseExpSlug;
				pusheditems['image'] = this.purchaseExpImage;
				pusheditems['type'] = this.purchaseExpType;
				pusheditems['line_total'] = this.purchaseExpPrice;
				pusheditems['qty'] = this.purchaseExpQuantity;
				pusheditems['variation_id'] = this.purchaseExpVerID;
				pusheditems['tax'] = this.purchaseExpTax;
				pusheditems['gratuity'] = gratuityValue;
				pusheditems['tax_percentage'] = Number(tax);
				pusheditems['gratuity_percentage'] = Number(gratuity);
				pusheditems['at_home'] = record?.at_home;
				pusheditems['instant_ship'] = record?.instant_ship;
				pusheditems['component_name'] = componentName;
				pusheditems['price_label'] = record?.price_label;
				pusheditems['alternate_quantity'] = record.alternate_quantity
				pusheditems['name_label'] = data?.name ? data?.name : '';
				pusheditems['city'] = record.alternate_quantity == 1 ? record?.city : '';
				pusheditems['state'] = record.alternate_quantity == 1 ? record?.state : '';
				pusheditems['people_count'] = record.alternate_quantity == 1 || data?.key ? data?.key : data;
				if (this.authUser) {
					pusheditems['user_id'] = this.authUser.id;
				}
				else {
					pusheditems['user_id'] = 0;
				}
				pusheditems['clickCart'] = this.clickCart;
				cartitems.push(pusheditems);
				this.cartService.sendMessage(JSON.stringify(cartitems));
				if (this.isBrowser) {
					localStorage.setItem('cart_details', JSON.stringify(cartitems));
				}
			} else {
				this.toastr.errorToastr("Already added in your cart.", 'Error!');
			}
			this.isLoading = false;
			setTimeout(() => {
				if (this.isBrowser) {
					var popupWrapElement = document.querySelector(".cartpopup-wrap");
					if (popupWrapElement) {
						popupWrapElement.classList.add('active');
					}
				}

			}, 100);
		}
	}


	/* FUNCTION TO ADD/REMOVE TO REGISTRY */
	addToRegistry(exp_id, type, index) {
		this.showRegChkmark = true;
		this.resultExp[index].is_show_ckbx = 1;     // show vebo V image.
		this.addexperience.addExperienceRegistry(exp_id, type, this.tokenkey).subscribe(res => {
			if (res.response == 'success') {
				this.messageService.sendTotalMessage(res.data);
				this.resultExp[index].is_show_ckbx = 0;    // hide vebo V image.
				this.resultExp[index].experience_status_msg = res.data.experience_status_msg;
				this.resultExp[index].add_reg_msg_class = res.data.add_reg_msg_class;
				this.resultExp[index].added_registry_type = res.data.added_registry_type;
				this.resultExp[index].experience_status = res.data.is_registry_status;
				this.resultExp[index].is_registry_status = res.data.is_registry_status;

			} else if (res.response == 'error') {
			}
		});
	}


	/* FUNCTION TO SHOW EXPERIENCE DETAILS POPUP */
	showExpDetails(id) {
		this.isLoading = true;
		var requestbody = { 'experience_id': id, request_page: 'other' };
		this.addexperience.getExperienceDetails(requestbody, this.tokenkey).subscribe(res => {
			if (res.response == 'success') {
				var responseData = res.data;
				if (responseData.variations_data.length > 0) {
					for (let k = 0; k < responseData.variations_data.length; k++) {
						if (responseData.variations_data[k].slug == 'buy-for-yourself') {
							responseData.is_buy_for_yourself = 1;
							responseData.buy_for_yourself_veriation_id = responseData.variations_data[k].id;
							break;
						} else {
							responseData.is_buy_for_yourself = 0;
							responseData.buy_for_yourself_veriation_id = 0;
						}
					}
				} else {
					responseData.is_buy_for_yourself = 0;
					responseData.buy_for_yourself_veriation_id = 0;
				}
				this.experienceDetails = [];
				this.experienceDetails = responseData;
				//this.additionalImages  	= 	this.experienceDetails.additional_images;

				// this.experienceDetailsPopup.show();
				this.experienceDetails.add_experience = 1;
				this.experienceDetails.resultOurRegistry = this.resultExp;
				this.ExpDetailService.sendMessage(this.experienceDetails);

			} else if (res.response == 'error') {
				//this.toastr.errorToastr(res.message, 'Error!'); 
			}
		});
		this.isLoading = false;
	}

	/* FUNCTION TO SHOW EXPERIENCE DETAILS POPUP */
	show_group_pricing_exp(id) {
		this.isLoading = true;
		var requestbody = { 'experience_id': id, 'request_page': 'other' };
		this.addexperience.getExperienceDetails(requestbody, this.tokenkey).subscribe(res => {
			if (res.response == 'success') {
				this.experienceDetails = res.data;
				this.data_for_dropdown_in_popup = res.data;
				this.experienceDetails.pricing_option = 1;
				this.data_for_dropdown_in_popup.pricing_option = 1;
				this.experienceDetails.other_page_data = 'other';
				//this.experienceDetailsPopup.show();
				this.ExpDetailService.sendMessage(this.experienceDetails);
			} else if (res.response == 'error') {
				// this.toastr.errorToastr(res.message, 'Error!'); 
			}
			this.isLoading = false;
		});
	}

	selected_amount(amount) {
		this.amount = amount;
	}

	add_gift_certificate() {
		this.messageService.sendGiftCertificate(this.certificate_data)
	}

	add_gift_event(e) {
		e.is_buy_for_yourself = 1;
		this.messageService.sendGiftCertificate(e);
	}

	ngOnDestroy() {
		// unsubscribe to ensure no memory leaks
		if (this.subscription != undefined && this.subscription != null) {
			this.subscription.unsubscribe();
		}
		if (this.getExpStatusChangedToMainComponentSubscription != undefined && this.getExpStatusChangedToMainComponentSubscription != null) {
			this.getExpStatusChangedToMainComponentSubscription.unsubscribe();
		}
	}

	onChangeSearch(event: any) {
		if (event && event?.query) {
			this.searchedItem = event?.query;
			this.onFiltering_after_debounce()
		} else {
			this.searchedItem = '';
		}
		if (event?.value) {
			this.search_id = event?.value?.id;
			this.type = event?.value?.type;
			this.searchedItem = "";
		} else {
			this.search_id = '';
			this.type = '';
		}
		this.page = 1;
		this.current_page = 0;
		this.resultExp = [];
		this.filteredGroups = [];
		const startDateParam = this.start_date !== undefined && this.start_date !== null ? this.start_date : '';
		const endDateParam = this.end_date !== undefined && this.end_date !== null ? this.end_date : '';

		this._location.replaceState('/location-region/' + this.locationSlug + '/' + this.categorySlug +
			"?page=" + this.page + "&exp_pos=" + ((this.page * 9) - 5) + "&is_booking=" + this.is_booking +
			(this.is_booking > 0 ? ("?start_date=" + startDateParam + "&end_date=" + endDateParam) : ''));
		this.getAllExperienceData();
	}

	/* onFiltering(e: FilteringEventArgs){
		this.save_filter_event=e;
	} */

	onFiltering_after_debounce(e?) {
		// let searchKeyword = e.text.trim();
		let requestbody = { 'location_slug': this.categorySlug, 'location_type': 'location-region/city' };
		this.addexperience.autocomplete_search(requestbody).subscribe(res => {
			if (res.response == 'success') {
				setTimeout(function () {
					this.autocompleteData = res.data;
					let autocompleteData = res?.data;
					this.autocompleteData = autocompleteData;
					e.updateData(this.autocompleteData);
				}, 10);
			}
		});
	}

	exp_detail(event: Event, slug, exp_pos, request_type = '') {
		event.preventDefault();
		var page_no = (this.page == this.last_page) ? this.page + 1 : this.page;
		this._location.replaceState('/location-region/' + this.locationSlug + '/' + this.categorySlug +
			"?start_date=" + (this.selectedDateRange?.length > 1 ? this.datePipe.transform(this.selectedDateRange[0], 'yyyy-MM-dd') : '') +
			"&end_date=" + (this.selectedDateRange?.length > 1 ? this.datePipe.transform(this.selectedDateRange[1], 'yyyy-MM-dd') : '') +
			"&page=" + (page_no - 1) + "&exp_pos=" + exp_pos + "&is_booking=" + this.is_booking);
		setTimeout(() => {
			this.router.navigate(['/experiences/' + slug], { queryParams: { date: this.selected_date, 'request_type': request_type } })
		}, 10)
	}

	getExpQuantity(data) {
		// Generate People Option Dropdown RFP 249.
		if (data?.length > 0) {
			data.forEach((element, i) => {
				let seats = this.max_quantity_count;
				let book_denominator = element.book_denominator;
				let individual_price = element.for_individual_price;
				let people_options = [];
				if (Number(seats) > 0) {
					for (let i = 1; i <= Number(seats); i++) {
						//let personOptions = {};
						if (i == 1) {
							var personName = 'Person';
						} else {
							var personName = 'People';
						}
						// book_denominator = 2 
						if (Number(book_denominator) > 1) {
							if ((Number(i) % Number(book_denominator)) === 0) {
								let pQty = Number(i) / Number(book_denominator);
								people_options.push({ 'key': i, 'value': i + ' ' + personName });
							}

						} else if (Number(individual_price) == 0) {
							if ((Number(i) % 2) === 0) {
								let pQty = Number(i) / 2;
								people_options.push({ 'key': i, 'value': i + ' ' + personName });
							}
						} else {
							people_options.push({ 'key': i, 'value': i + ' ' + personName });
						}
						if (i == 10) {
							break;
						}
					}
				}
				element['book_quantity_options'] = people_options;
				if (element?.price_label_dropdown?.length > 0) {
					element['book_quantity_options'] = element?.price_label_dropdown

				}
			});
		}
		// Check If Booking People selection quantity is allowed on experience end or not.

	}
	addCartQuantity(i, record, id) {
		var cartitems: any = [];
		if (this.isBrowser) {
			if (localStorage.getItem('cart_details')) {
				cartitems = JSON.parse(localStorage.getItem('cart_details'));
			}
		}

		let hasPresentOn = cartitems.find(
			function (el) {
				if (el.product_id === record?.id) {
					return true;
				} else {
					return false;
				}
			}
		);
		if (!hasPresentOn) {

			for (let i = 0; i < this.resultExp.length; i++) {
				let element = document.getElementById(id + i)
				if (element) {
					element.classList.remove("active");
				}
			}
			let element = document.getElementById(id + i)
			element.classList.add("active");
		}
		else {
			this.toastr.errorToastr("Already added in your cart.", 'Error!');
		}
	}

	removeClass(i, id) {

		let element = document.getElementById(id + i)
		if (element) {
			element.classList.remove("active");
		}
	}

	onFiltering(event: any) {
		this.modelChanged2.next(event?.query);
		this.Query = event.query;
	}


	onFilteringAfterDebounce(query: string) {
		const searchKeyword = query.trim();
		const requestbody = {
			search: searchKeyword,
			location_slug: this.categorySlug,
			location_travel: this.location_travel,
			location: this.location,
			city: this.city,
			at_home: this.at_home
		};
		this.addexperience.autocomplete_search(requestbody).subscribe(res => {
			if (res.response === 'success') {
				setTimeout(() => {
					this.autocompleteData = res.data;
					if (this.autocompleteData) {
						this.groupItemsDynamically(this.autocompleteData);
					}
				}, 10);
			}
		});
	}

	groupItemsDynamically(autocompleteData: any) {
		const groups: { [key: string]: any } = {};

		autocompleteData?.forEach(item => {
			const groupKey = item.type;
			if (!groups[groupKey]) {
				groups[groupKey] = {
					label: `By ${item.type === 'category' ? 'Category' : 'Name'}`,
					type: item.type,
					items: []
				}
			}
			groups[groupKey].items?.push({ id: item.id, value: item.value, label: item.label, type: item.type });
		});
		this.groupedData = Object.values(groups);
		if (this.groupedData) {
			this.filterGroupedCity(this.groupedData);
		}
	}

	filterGroupedCity(groupedData: any) {
		let query = this.Query
		let filteredGroups = [];

		for (let optgroup of groupedData) {
			let filteredSubOptions = this.filterService.filter(optgroup.items, ['label'], query, "contains");
			if (filteredSubOptions && filteredSubOptions.length) {
				filteredGroups?.push({
					label: optgroup.label,
					value: optgroup.value,
					items: filteredSubOptions
				});
			}
		}

		this.filteredGroups = filteredGroups;
	}
	onEnter(event) {
		if (event.key === "Enter") {
			this.onFilteringAfterDebounce(this.Query)
			this.searchedItem = this.Query;
			this.search_id = '';
			this.type = '';
			this.page = 1;
			this.current_page = 0;
			this.resultExp = [];
			const startDateParam = this.start_date !== undefined && this.start_date !== null ? this.start_date : '';
			const endDateParam = this.end_date !== undefined && this.end_date !== null ? this.end_date : '';

			this._location.replaceState('/location-region/' + this.locationSlug + '/' + this.categorySlug +
				"?page=" + this.page + "&exp_pos=" + ((this.page * 9) - 5) + "&is_booking=" + this.is_booking +
				(this.is_booking > 0 ? ("?start_date=" + startDateParam + "&end_date=" + endDateParam) : ''));
			this.getAllExperienceData();

		}
	}

	onSchedulingDateSelect(event: any) {

		if (this.isDateSelected && event && event.length === 2) {
			const startDate = event[0];
			const endDate = event[1];
			const dateClasses: DatepickerDateCustomClasses[] = [];

			let currentDate = new Date(startDate);
			while (currentDate <= endDate) {
				dateClasses.push({
					date: new Date(currentDate),
					classes: ['date-range-selected']
				});
				currentDate.setDate(currentDate.getDate() + 1);
			}

			this.dateCustomClasses = dateClasses;
			this.selectedDateRange = event;
			this.page = 1;
			this.current_page = 1;
			this.last_page = 1;
			this.exp_pos = 0;
		}
		this.isDataLoading = false;
		this.start_date = this.datePipe.transform(this.selectedDateRange[0], 'yyyy-MM-dd');
		this.end_date = this.datePipe.transform(this.selectedDateRange[1], 'yyyy-MM-dd');
		let url = '/location-region/' + this.locationSlug + '/' + this.categorySlug +
			"?page=" + this.page + "&exp_pos=" + this.exp_pos + "&is_booking=" + this.is_booking +
			"&start_date=" + (this.selectedDateRange?.length > 1 ?
				this.start_date : '') +
			"&end_date=" + (this.selectedDateRange?.length > 1 ?
				this.end_date : '')

		this._location.replaceState(url);
		if (this.start_date !== undefined && this.start_date !== null &&
			this.end_date !== undefined && this.end_date !== null) {
				// if (is_booking == 2)
		}
		this.resultExp = [];
		this.getAllExperienceData();
	}

	addMetaTags() {
		let url
		if (this.isBrowser) {
			url = window?.location?.href
		}
		if (this.result?.seo_title && this.result?.seo_title != '') {
			this.title.setTitle(this.result?.seo_title);
			this.metaService.updateTag({ property: 'og:title', content: this.result?.seo_title });
		} else {
			this.title.setTitle(this.result?.name);
			this.metaService.updateTag({ property: 'og:title', content: this.result?.name });
		}
		this.metaService.updateTag({ property: 'og:url', content: this.pageUrl });
		if (this.result?.image) {
			this.metaService.updateTag({ property: 'og:image', content: this.image_url + this.result?.image });
		}
		this.metaService.updateTag({ property: 'og:description', content: this.result?.seo_description });
		this.metaService.updateTag({ property: 'description', content: this.result?.seo_description });
	}

	changeView() {
		this.gridView = !this.gridView;
	}

	clearDate() {
		this.selectedDateRange = [];
		this.page = 1;
		this.current_page = 1;
		this.last_page = 1;
		this.exp_pos = 0;
		this.resultExp = [];
		this.start_date = '';
		this.end_date = '';
		let url = '/location-region/' + this.locationSlug + '/' + this.categorySlug +
			"?page=" + this.page + "&exp_pos=" + this.exp_pos + "&is_booking=" + this.is_booking +
			"&start_date=" + (this.selectedDateRange?.length > 1 ?
				this.start_date : '') +
			"&end_date=" + (this.selectedDateRange?.length > 1 ?
				this.end_date : '')
		this._location.replaceState(url);
		// if (this.is_booking == 2) {
	    // }

		this.getAllExperienceData();

	}
}
